module.exports = __webpack_public_path__ + "static/img/icon_property.a91c9371.png";